var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"w-dropdown"},[_vm._t("default"),_vm._t("dropdown")],2)}
var staticRenderFns = []

export { render, staticRenderFns }